module.exports = __webpack_public_path__ + "img/agro-login.44a26dc6.png";